export default __webpack_public_path__ + "static/desktop-bg-left-mask-5868e13302b74551d60d20993d95d56c.png";